module.exports = __webpack_public_path__ + "img/icon-down.d5324f02.svg";